const clearOffers = [
  'newyear50',
  'newjoy50',
  'unleash50',
  'holiday50',
  'mothersday50',
  'memorial50',
  'memorial60',
  'sam60',
  'whistle30',
  'brookswhistle',
  'ldsupplements30',
  'ldmeals50',
  'trialjoy50',
  'bfcm2024',
  'new50',
  '0479jejcxt5k',
  '1cxq9pn6d4vh',
  '50brooks',
  '50holiday',
  '50remi',
  '50unleash',
  'adriana60',
  'adriana20',
  'acklove',
  'golden',
  'plana10',
  'trevor50',
  'luckydog',
  'topdog',
  'bazaar',
  'comeback50',
  'rowayton',
  'tnp50',
  'kayla50',
  'vetstreet',
  'westmichigan',
  'joycrew20',
  'nycdogparade',
  'chrissy20',
  'brooke50',
  'loopwell',
  'newcanaan50',
  'nisha50',
  'joyrides50',
  'sam20',
  'nyc50',
  'cisco',
  'whistle50',
  'dogppl60',
  'sm60',
  'pf',
  'barkst',
  'brooks60',
  'cartjoy60',
  'molly',
  'dani60',
  'julie60',
  'sarah60',
  'kat60',
  'barkinthepark',
  'verlisha50',
  'getjoy50',
  'joy60',
  'joy50',
  'jojacqs20',
  'chen20',
  'cara20',
  'test123',
  'sarah20',
  'kat20',
  'julie20',
  'cartjoy20',
  'mothersdaytest',
  'tinuititest',
  'dani20',
  'lara20',
  'jen20',
  'fern20',
  'victoria20',
  'ocean60',
  'daffodill60',
  'getjoy10',
  'discounterror_jenny',
  'whistle60',
  'bunnyhop60',
  'vail60',
  'old-holiday50',
  'old-50holiday',
  'lev20',
  'remi50',
  'brooks50',
  'shell23',
  'francenereferral',
  'referral50',
  'pennyreferral',
  'archie100',
  'tilly50',
  'tyler20',
  'daffodil',
  'rumble20',
  'olivia20',
  'pasea20',
  'local',
  'court20',
  'msk20',
  'thankyou50',
  'tom50gift',
  'vdaytreat',
  'flashfreeze',
  'playing',
  'anubis20',
  'vail',
  'goop',
  'joyfamvip',
  'larrymarks40',
  'freezeday',
  'joygift40',
  'cyber30',
  'getjoymail22',
  'dice20',
  'holidayjoy50',
  'bfvip40',
  'joymailpr2',
  'brandy20',
  'joy20',
  'moretreats',
  'joymailpr',
  'joymail22',
  'love15',
  'firstjoy15',
  'becky20',
  'jessica20',
  'kenny20',
  'max20',
  'brooks20',
  'localship',
  'tryjoy',
  'dca',
  'rowaytonfarmersmarket',
  'ciscostamford',
  'momsnetwork',
  'memorialday30',
  'memorialday65',
  'bugs20',
  'talkshop20',
  'unleash30',
  'fool30',
  'cody20',
  'carla20',
  'bradley20',
  'petshoppingtv',
  'greenwich30',
  'darien10',
  'shayla20',
  'makeawish',
  'sai20',
  'jenna20',
  'leslie20',
  'brianne20',
  'trevor20',
  'whitney20',
  'sheryl20',
  'austin20',
  'onetime20',
  'onetime15',
  'gjfriends',
  'joe10',
  'emp3619',
  'fd50',
  'farmersmarket21',
  'fdmailer',
  'gjfreeship',
  'freechew',
  'influencer',
  'givelove',
  'wholesale',
  'joejoe',
  'unleash20',
  'trick',
  'blogger',
  'tricks',
  'friends2021',
  'surveyjoy',
  'treats10',
  'laborday',
  'ckp0te8p97zm',
  'joy10',
  'joytoy',
  'hawketest'
];

const codeDetails = [
  // {
  //     "name": "dogppl50",
  //     "announcement_text": `Get <strong style="text-transform: uppercase">50% OFF</strong> new Meal or Supplement plans with code <strong style="text-transform: uppercase">DOGPPL50</strong>!`,
  //     "apply_ss": true,
  //     "apply_one_time": false,
  //     "existing_subscribers": false,
  //     "display_amount": "50%",
  //     "discount": 0.5,
  //     "ss_message": `<span class="sub-intro--subtext">After your first two subscription orders, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
  //     "ss_frequency_message": `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>50% off</strong> your first shipment! </span>`,
  //     "item_ids": [4612542464046, 4699848278062, 6969058656302, 6969056002094, 6969058623534, 7042281439278, 7041842249774]
  // },
  // {
  //     "name": "new50",
  //     "announcement_text": `<strong>50% Off</strong> First New Meal Plan Order + Free Gifts`,
  //     "apply_ss": true,
  //     "apply_one_time": false,
  //     "existing_subscribers": true,
  //     "display_amount": "50%",
  //     "discount": 0.5,
  //     "ss_message": `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
  //     "ss_frequency_message": `<span data-content="conditional-content" data-content-type="intro-offer">By creating a new Meal Plan, you’ll receive <strong>50% off</strong> your first shipment! </span>`,
  //     "item_ids": [4612542464046, 4699848278062, 7042281439278, 7041842249774, 7101517758510],
  //     "includes_gwp": true,
  //     "discount_type": "automatic",
  //     // "cart_threshold_gifts": [
  //     //     {
  //     //         "threshold": 75,
  //     //         "title": "Free Shipping",
  //     //         "image_url": "https://cdn.shopify.com/s/files/1/0015/5919/9790/files/Shipping_GWP.jpg?v=1731276700"
  //     //     },
  //     //     {
  //     //         "gift_item_id": 41179078098990,
  //     //         "threshold": 100,
  //     //         "title": "Mystery Gift",
  //     //         "checkout_blocks_id": "67326792b6560e1a4fe6fbd0",
  //     //         "image_url": "https://cdn.shopify.com/s/files/1/0015/5919/9790/files/Mystery_Gift_100x.jpg?v=1731523338"
  //     //     },
  //     //     {
  //     //         "gift_item_id": 41176923963438,
  //     //         "threshold": 125,
  //     //         "title": "Treats (2 Bags)",
  //     //         "checkout_blocks_id": "673267ed7b5065c1f1485bd2",
  //     //         "image_url": "https://cdn.shopify.com/s/files/1/0015/5919/9790/files/Treats_Gift_100x.jpg?v=1731276700"
  //     //     }
  //     // ]
  // },
  // {
  //     "name": "ldmeals50",
  //     "announcement_text": `Get <strong style="text-transform: uppercase">50% OFF</strong> new Meal Plans with code <strong>LDMEALS50</strong>!`,
  //     "apply_ss": true,
  //     "apply_one_time": false,
  //     "existing_subscribers": true,
  //     "display_amount": "50%",
  //     "discount": 0.5,
  //     "ss_message": `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
  //     "ss_frequency_message": `<span data-content="conditional-content" data-content-type="intro-offer">By creating a new Meal Plan, you’ll receive <strong>50% off</strong> your first shipment! </span>`,
  //     "item_ids": [4612542464046, 4699848278062, 7042281439278, 7041842249774, 7101517758510],
  //     "discount_type": "automatic",
  //     "stackable_offers": [
  //         "ldsupplements30"
  //     ],
  // },
  // {
  //     "name": "ldsupplements30",
  //     "announcement_text": `Get <strong style="text-transform: uppercase">50% OFF</strong> new Meal Plans with code <strong>LDSUPPLEMENTS50</strong>!`,
  //     "apply_ss": true,
  //     "apply_one_time": false,
  //     "existing_subscribers": true,
  //     "display_amount": "30%",
  //     "discount": 0.7,
  //     "ss_message": `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
  //     "ss_frequency_message": `You're saving <strong>30%</strong> on your first shipment by shopping our <strong>Labor Day Sale!</strong> </span>`,
  //     "item_ids": [6969056002094, 6969058656302, 6969058623534],
  //     "discount_type": "automatic",
  //     "stackable_offers": [
  //         "ldmeals50"
  //     ],
  // },
  {
    name: 'vic60',
    announcement_text: `Get <strong style="text-transform: uppercase">60% OFF</strong> new Meal or Supplement plans with code <strong>VIC60</strong>!`,
    apply_ss: true,
    apply_one_time: false,
    existing_subscribers: true,
    display_amount: '60%',
    discount: 0.4,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>60% off</strong> your first shipment! </span>`,
    item_ids: [
      4612542464046, 4699848278062, 6969058656302, 6969056002094, 6969058623534,
      7042281439278, 7041842249774
    ],
    custom_content_id: 'post_memorial_24'
  },
  {
    name: 'kaylak9',
    announcement_text: `Your discount code <strong style="text-transform: uppercase">KAYLAK9</strong> for <strong>30% off</strong> your order will be applied automatically at checkout.`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '30%',
    discount: 0.7,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>35% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'devon20',
    announcement_text: `Your discount code <strong style="text-transform: uppercase">DEVON20</strong> for <strong>20% off</strong> your order will be applied automatically at checkout.`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'remi20',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">REMI20</strong>!`,
    apply_ss: false,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'asf20',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">ASF20</strong>!`,
    apply_ss: false,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'hudson20',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">HUDSON20</strong>!`,
    apply_ss: false,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'newt',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">NEWT</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'activedog20',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">ACTIVEDOG20</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'tilly20',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">TILLY20</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'linda',
    announcement_text: `You're saving 30% on your entire order with code <strong style="text-transform: uppercase">LINDA</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '30%',
    discount: 0.7,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'asf',
    announcement_text: `You're saving 30% on your entire order with code <strong style="text-transform: uppercase">ASF</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '30%',
    discount: 0.7,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'return30',
    announcement_text: `Exclusive Offer: <strong>30% OFF</strong> new Fresh Freeze Dried Subscriptions!`,
    apply_ss: true,
    apply_one_time: false,
    existing_subscribers: true,
    display_amount: '30%',
    discount: 0.7,
    ss_message: `<span class="sub-intro--subtext">After your first three autoship orders, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>30% off</strong> your first three shipments! </span>`,
    item_ids: [7044876435502],
    discount_type: 'automatic'
  },
  {
    name: 'todd',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">TODD</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'abby',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">ABBY</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'mickey',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">MICKEY</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'uberdog20',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">UBERDOG20</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'steamboat20',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">STEAMBOAT20</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'vail20',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">VAIL20</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'riggs',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">RIGGS</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'goose',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">GOOSE</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'brianna',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">BRIANNA</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'lulunora',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">LULUNORA</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'bdrr',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">BDRR</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'poppy',
    announcement_text: `You're saving 30% on your entire order with code <strong style="text-transform: uppercase">POPPY</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '30%',
    discount: 0.7,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'samson20',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">SAMSON20</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  },
  {
    name: 'bday20',
    announcement_text: `You're saving 20% on your entire order with code <strong style="text-transform: uppercase">BDAY20</strong>!`,
    apply_ss: true,
    apply_one_time: true,
    existing_subscribers: true,
    display_amount: '20%',
    discount: 0.8,
    ss_message: `<span class="sub-intro--subtext">After your first subscription order, your recurring price will be <strong data-content-id="recurring-discount-amount">15% off</strong> the one-time price.</span>`,
    ss_frequency_message: `<span data-content="conditional-content" data-content-type="intro-offer">By creating a Meal or Supplement Plan, you’ll receive <strong>20% off</strong> your first shipment! </span>`,
    item_ids: []
  }
];

const gwpSets = [
  {
    id: 'mystery-100-treats-2bag-125',
    type: 'cart_threshold',
    options: [
      {
        threshold: 75,
        title: 'Free Shipping',
        image_url:
          'https://cdn.shopify.com/s/files/1/0015/5919/9790/files/Shipping_GWP.jpg?v=1731276700'
      },
      {
        gift_item_id: 41179078098990,
        threshold: 100,
        title: 'Mystery Gift',
        checkout_blocks_id: '67326792b6560e1a4fe6fbd0',
        image_url:
          'https://cdn.shopify.com/s/files/1/0015/5919/9790/files/Mystery_Gift_100x.jpg?v=1731523338'
      },
      {
        gift_item_id: 41176923963438,
        threshold: 125,
        title: 'Treats (2 Bags)',
        checkout_blocks_id: '673267ed7b5065c1f1485bd2',
        image_url:
          'https://cdn.shopify.com/s/files/1/0015/5919/9790/files/Treats_Gift_100x.jpg?v=1731276700'
      }
    ]
  },
  {
    id: 'treats-2bag-150',
    type: 'cart_threshold',
    options: [
      {
        threshold: 75,
        title: 'Free Shipping',
        image_url:
          'https://cdn.shopify.com/s/files/1/0015/5919/9790/files/Shipping_GWP.jpg?v=1731276700'
      },
      {
        gift_item_id: 41176923963438,
        threshold: 150,
        title: 'Treats (2 Bags)',
        checkout_blocks_id: '673267ed7b5065c1f1485bd2',
        image_url:
          'https://cdn.shopify.com/s/files/1/0015/5919/9790/files/Treats_Gift_100x.jpg?v=1731276700'
      }
    ]
  }
];

// --------------------------------------------------------------------------------------------

// Required variables

// --------------------------------------------------------------------------------------------

const customContent = {
  post_memorial_24: [
    {
      section_id:
        'shopify-section-template--14599233208366__expanded_slideshow_pB3JJQ',
      child_content: [
        {
          selector: '.h1.mt0.mb0.content--title_LgEnjX',
          text_content: '60% Off'
        },
        {
          selector: '.subtitle.mt0.mb0.content--subtitle_tQhRxr',
          text_content: 'First Autoship Box of Fresh'
        }
      ]
    },
    {
      section_id: 'shopify-section-template--14599232749614__slideshow_Hr89AU',
      child_content: [
        {
          selector: `[data-live-text-setting="section.template--14599232749614__slideshow_Hr89AU.block.image_aBapbJ.subheading/escape"]`,
          text_content: 'Take 60% Off First Autoship Box!'
        }
      ]
    },
    {
      section_id: 'Linklist-collections-all-products-20221',
      child_content: [
        {
          selector: `a[href="/pages/nutrition-plan"] > [data-content="promo-image-parent"] img`,
          src: 'https://cdn.shopify.com/s/files/1/0015/5919/9790/files/60-off-mega_650x650.jpg?v=1716234570',
          alt: '60% Off First Autoship Box Plus Free Bag of Treats!'
        }
      ]
    },
    {
      section_id: 'SiteHeader',
      child_content: [
        {
          selector: `a[href="/pages/nutrition-plan"] > [data-content="promo-image-parent"] img`,
          src: 'https://cdn.shopify.com/s/files/1/0015/5919/9790/files/60-off-mega_650x650.jpg?v=1716234570',
          alt: '60% Off First Autoship Box Plus Free Bag of Treats!'
        }
      ]
    },
    {
      section_id: 'Slideshow-template--14599232749614__slideshow_Hr89AU',
      child_content: [
        {
          selector:
            '.hero__subtitle > .animation-cropper > .animation-contents',
          text_content: 'Take 60% OFF your First Autoship Box'
        }
      ]
    }
  ],
  bfcm24_override: [
    {
      section_id:
        'shopify-section-template--14599233208366__video_hero_blocks_PbRjUc',
      child_content: [
        {
          selector: '.block--heading_FgwcAY',
          text_content: '55% Off'
        },
        {
          selector: '.block--heading_WJEDWQ',
          text_content: 'New Meal Plans'
        }
      ]
    },
    {
      section_id: 'shopify-section-template--14599233208366__rich_text_eM97J9',
      hide: true
    },
    {
      section_id:
        'shopify-section-template--14599233208366__icons_with_content_PTCfR7',
      hide: true
    },
    {
      section_id:
        'shopify-section-template--14599233208366__icons_with_content_PTCfR7',
      hide: true
    },
    {
      section_id: 'shopify-section-template--14599233208366__rich_text_g7FwC7',
      hide: true
    },
    {
      section_id:
        'shopify-section-template--14599232749614__advanced_content_TcAWxL',
      hide: true
    },
    {
      section_id: 'MainContent',
      child_content: [
        {
          selector: '.bfcm-offer--clip',
          hide: true
        }
      ]
    }
  ]
};

// 'GJ%20%7C%2003.14.25%20%7C%20%20FFD%20OTO%20Repurchase%20for%20Feb%202025%20purchasers%20%2801JP65W3QC2HKHV7TG6XHFXW4P%29'
const urlParameters = new URLSearchParams(window.location.search);
let isRepurchaseSession =
  urlParameters.get('utm_campaign') ===
  'GJ | 03.14.25 |  FFD OTO Repurchase for Feb 2025 purchasers (01JP65W3QC2HKHV7TG6XHFXW4P)';

let offer = sessionStorage.getItem('offer') || null;

const defaultGwpSet = '';
//const defaultGwpSet = 'treats-2bag-150'

let gwpSet; // This gets defined after offer initialization

function setGwpSet(setId) {
  if (!setId) return null;

  let matchedGiftSet =
    gwpSets.find((set) => set.id === setId) ||
    gwpSets.find((set) => set.id === defaultGwpSet);
  if (matchedGiftSet) {
    return matchedGiftSet;
  }
  return null;
}

const pageLocation = window.location.href;

let existingSubscriber = false;
let activeSubscriber = false;
if (customerId) {
  if (
    customerTags.includes('Inactive Subscriber') ||
    customerTags.includes('Active Subscriber')
  ) {
    existingSubscriber = true;
    if (customerTags.includes('Active Subscriber')) {
      activeSubscriber = true;
    }
  }
}

const wholesaleAccount =
  customerTags && customerTags.toString().toLowerCase().includes('wholesale');

// --------------------------------------------------------------------------------------------

// Functions

// --------------------------------------------------------------------------------------------

// Returns data related to offer
function parseOfferDetails(query, type = 'code') {
  if (!query) return null;

  const offerDetails = codeDetails.find(
    (code) => code.name === query.toLowerCase()
  ) || {
    name: query,
    announcement_text: `Your discount code <strong style="text-transform: uppercase">${query}</strong> will be applied automatically at checkout.`,
    apply_ss: false,
    apply_one_time: true,
    existing_subscribers: false,
    item_ids: []
  };
  return offerDetails;
}

// Returns autoship discount percentage
function parseDefaultAutoshipDiscount(frequency) {
  if (frequency === 2) {
    return 0.85;
  }
  if (frequency > 2) {
    return 0.8;
  }
  return 1;
}

// Checks and sets offer based on browser cookies
function parseOfferCookie() {
  const discountCodeCookie = document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith('discount_code='));
  if (discountCodeCookie) {
    let code = discountCodeCookie.split('=')[1].toLowerCase();
    return;

    // if (code !== 'getjoy50') {
    offer = code;
    console.log('parseOfferCookieOffer:: ', offer);
    sessionStorage.setItem('offer', code);
    // }
    saveOfferLocally(code);
  }
}

function saveOfferLocally(code) {
  if (!localStorage.getItem('savedOffer')) {
    const offerJson = {
      code: code,
      initialized: new Date()
    };
    localStorage.setItem('savedOffer', JSON.stringify(offerJson));
  }
}

// Sets default offer when needed
function setDefaultOffer(newOffer) {
  const offerDetails = parseOfferDetails(newOffer);
  if (existingSubscriber && offerDetails.existing_subscribers !== true) {
    return;
  }
  offer = newOffer;
  sessionStorage.setItem('offer', newOffer);

  if (
    !offerDetails.discount_type ||
    (offerDetails.discount_type && offerDetails.discount_type !== 'automatic')
  ) {
    document.cookie = `discount_code=${offer}; samesite=lax`;
    fetch(`/discount/${offer}`)
      .then(function () {
        // After the discount code has been applied, force the cart to update so the discount is visible instantly
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: {}
          })
        });
      })
      .catch(function (error) {
        console.error('Error:', error);
      });
  }
}

// Clear offer if it does not apply to the customer
function clearCurrentOffer() {
  document.cookie =
    'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  offer = null;
  sessionStorage.removeItem('offer');
}

// Convert price string to number float
function parsePriceString(string) {
  return parseFloat(string.replace('$', '').replace(' ', ''));
}

// --------------------------------------------------------------------------------------------
// Tiered Offer Type Support (BFCM 2023)
// --------------------------------------------------------------------------------------------

async function checkOfferToggle() {
  if (!offer) return; // Do nothing if no offer exists
  const offerData = parseOfferDetails(offer);
  if (!offerData.paired_offer) return; // Do nothing if the offer does not have another paired

  let cartContents = await getCartItems();
  cartContents = cartContents.items;

  if (cartContents.length === 0) return; // Do nothing if cart is currently empty

  let hasSubscriptions = false;
  for (let i = 0; i < cartContents.length; i++) {
    let item = cartContents[i];
    if (item.selling_plan_allocation) {
      hasSubscriptions = true;
      break;
    }
  }

  if (hasSubscriptions && !offerData.apply_ss) {
    setDefaultOffer(offerData.paired_offer);
    displayOfferAnnouncement();
    //applyFormPricingOffer() // RC Native PDP's
    applyOfferDisplayPrice();
  } else if (!hasSubscriptions && !offerData.apply_one_time) {
    setDefaultOffer(offerData.paired_offer);
    displayOfferAnnouncement();
    //applyFormPricingOffer() // RC Native PDP's
    applyOfferDisplayPrice();
  }
}

// --------------------------------------------------------------------------------------------
// Announcement bar
// --------------------------------------------------------------------------------------------

// Handles routing of announcement bar content related to offer
function displayOfferAnnouncement(content = null) {
  const announcementOverrides = ['ldmeals50', 'ldsupplements30'];

  if (!offer && !content) return;

  if (content && content !== '') {
    const offerAnnouncement = document.querySelector(
      '[data-message-id="offer"]'
    );
    if (offerAnnouncement) {
      offerAnnouncement.innerHTML = content;
    }
    return;
  }

  let offerData = offer ? parseOfferDetails(offer) : null;

  if (offer && !announcementOverrides.includes(offer)) {
    const offerAnnouncement = document.querySelector(
      '[data-message-id="offer"]'
    );
    if (offerAnnouncement && offerData.announcement_text) {
      if (offer) {
        offerAnnouncement.innerHTML = offerData.announcement_text;
      } else {
        // if (offerAnnouncement && offerAnnouncement.getAttribute('data-persist') !== 'true') {
        //     field.remove()
        // }
      }
    }
  }
  if (offerData && offerData.custom_content_id) {
    handleContentUpdates(offerData.custom_content_id);
  }
  if (
    offerData &&
    offerData.display_amount &&
    offerData.display_amount !== '50%'
  ) {
    const buttons = Array.from(document.querySelectorAll('.btn'));
    const buttonsToUpdate = buttons.filter((button) =>
      button.textContent.includes('50%')
    );
    buttonsToUpdate.forEach((button) => {
      button.textContent = button.textContent.replace(
        '50%',
        offerData.display_amount
      );
    });
  }
}

function handleContentUpdates(contentId) {
  const contentGroup = customContent[contentId];

  contentGroup.forEach((item) => {
    const section = document.getElementById(item.section_id);
    if (section) {
      if (item.hide) {
        section.remove();
      } else {
        item.child_content.forEach((child) => {
          const target = section.querySelector(child.selector);
          if (target) {
            if (child.text_content) {
              target.textContent = child.text_content;
            }
            if (child.src) {
              target.classList.remove('lazyload');
              target.src = child.src;
            }
            if (child.alt) {
              target.alt = child.alt;
            }
            if (child.hide) {
              target.remove();
            }
          }
        });
      }
    }
  });
}

// --------------------------------------------------------------------------------------------
// Recharge Module Updates
// --------------------------------------------------------------------------------------------

// Determine if RC module listener is needed
function checkRechargeState() {
  const variantDataItem = document.querySelector(
    '[data-content="variants-json"]'
  );
  if (
    !variantDataItem &&
    document.querySelectorAll('[name="properties[_subscription_frequency]"]')
      .length > 0
  ) {
    let subscriptionButtons = document.querySelectorAll(
      'input[value="subsave"]'
    );
    if (subscriptionButtons.length > 0) {
      updateSubscriptionSelects();
      // setFrequencyListeners()
      setAutoshipListeners();
      setInitialAutoshipSelection();
      if (offer) {
        setTimeout(() => applyFormPricingOffer(), 300);
      }
    } else {
      if (offer) {
        setTimeout(() => applyFormPricingOffer(), 300);
      }
      //awaitRechargeLoad();
    }
  }
}

// --------------------------------------------------------------------------------------------
// Content Updates
// --------------------------------------------------------------------------------------------

function createPriceClones() {
  let productForms = document.querySelectorAll('[data-content="product-form"]');
  productForms.forEach((form) => {
    let hasSubscription =
      form.querySelectorAll('[data-price-onetime]').length > 0;
    if (hasSubscription) {
      let defaultPrice = form.querySelector('.product-block--price');
      let priceClone = defaultPrice.cloneNode(true);
      priceClone.removeAttribute('data-price-mutation-watcher');
      priceClone.setAttribute('data-price-clone', 'true');
      defaultPrice.classList.add('hidden');
      defaultPrice.parentNode.insertBefore(
        priceClone,
        defaultPrice.nextSibling
      );
    }
  });
}

function updateSubscriptionSelects() {
  let productForms = document.querySelectorAll('[data-content="product-form"]');
  productForms.forEach((form) => {
    setTimeout(function () {
      const selectEl = form.querySelector('[data-plans-dropdown]');
      editSelectOptions(selectEl, form);
      setFrequencyListener(selectEl);
    }, 200);
  });
}

let initialSelectionSet = false;

function setInitialAutoshipSelection() {
  let productForms = document.querySelectorAll('[data-content="product-form"]');
  productForms.forEach((form) => {
    if (!initialSelectionSet) {
      initialSelectionSet = true;
      setTimeout(function () {
        let options = form
          .querySelector('[data-plans-dropdown]')
          .querySelectorAll('option');
        options[1].selected = true;

        form
          .querySelectorAll('[data-price-subsave]')
          .forEach((displayPrice) => {
            let comparePrice = displayPrice.textContent;
            displayPrice.innerHTML = `$${options[1].getAttribute('data-frequency-unit-price')} <span style="text-decoration: line-through; font-size: 0.85em; opacity: 0.7">$${comparePrice}</span>`;
          });
      }, 200);
    }
  });
}

function parseSelectedVariantId(formEl) {
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  if (urlParams.get('variant')) {
    return urlParams.get('variant');
  }
  return formEl.querySelector('select[name="id"]').value;
}

function parseOptionPrice(discountValue, form) {
  let frequencyPercentage = discountValue * 0.01;
  let priceMultiplier = 1 - frequencyPercentage;
  let variantId = parseSelectedVariantId(form);
  let option = form
    .querySelector('select[name="id"]')
    .querySelector(`option[value="${variantId}"]`);
  let selectedFullPrice = parseFloat(option.textContent.split('$')[1]);
  let optionFreqPrice = selectedFullPrice * priceMultiplier;
  return optionFreqPrice.toFixed(2);
}

function editSelectOptions(select, formEl) {
  let options = select.querySelectorAll('option');
  options.forEach((option) => {
    let frequencyValue = parseInt(
      option
        .getAttribute('data-plan-option')
        .replace('Delivery every ', '')
        .replace(' Weeks', '')
        .replace(' Week', '')
    );
    let frequencyDiscount = 15;
    if (frequencyValue > 2) {
      frequencyDiscount = 20;
    }
    if (frequencyValue === 1) {
      frequencyDiscount = 0;
      option.textContent += ` (One Time Price)`;
      // option.textContent += ` (+$9.99 Shipping)`
    } else {
      option.textContent += ` (${frequencyDiscount}% Off)`;
    }

    option.setAttribute('data-frequency-value', frequencyValue);
    option.setAttribute('data-frequency-discount', frequencyDiscount);
    let optionDiscountPrice = parseOptionPrice(frequencyDiscount, formEl);
    option.setAttribute('data-frequency-unit-price', optionDiscountPrice);
  });
}

function parseAutoShipSelection(productForm) {
  let autoshipSelected = productForm.querySelector(
    '.rc_widget__option--subsave.rc-option--active'
  );
  let autoshipProps = productForm.querySelector(
    '[name="properties[_subscription_frequency]"]'
  );
  if (autoshipProps) {
    if (autoshipSelected) {
      let sellingPlan = productForm.querySelector('[name="selling_plan"]');
      autoshipProps.value = sellingPlan
        .querySelector(`option[value="${sellingPlan.value}"]`)
        .getAttribute('data-frequency-value');
    } else {
      autoshipProps.value = null;
    }
  }
}

function parseSelectionPrice(formEl) {
  let idSelect = formEl.querySelector('select[name="id"]');
  if (idSelect) {
    return idSelect
      .querySelector('option[selected]')
      .textContent.split(' - $')[1]
      .trim();
  } else {
    return null;
  }
}

function applyOfferDisplayPrice() {
  let productForms = document.querySelectorAll('[data-content="product-form"]');
  productForms.forEach((form) => {
    let subscriptionSelection = form.querySelector('.rc-option--active');
    if (subscriptionSelection) {
      form.querySelector('[data-price-clone="true"]').innerHTML =
        `<div class="product-price--clone">${subscriptionSelection.querySelector('.rc-option__price').innerHTML}</div>`;
    } else {
      if (!form.querySelector('[data-content="discount-original-price"]')) {
        let offerData = parseOfferDetails(offer);
        if (!offerData) return;
        if (
          (offerData.apply_one_time && offerData.item_ids.length === 0) ||
          (offerData.apply_one_time &&
            offerData.item_ids.length > 0 &&
            offerData.item_ids.includes(
              form.getAttribute('data-form-product')
            )) ||
          (offerData.paired_offer &&
            parseOfferDetails(offerData.paired_offer).apply_one_time &&
            parseOfferDetails(offerData.paired_offer).item_ids.length === 0) ||
          (offerData.paired_offer &&
            parseOfferDetails(offerData.paired_offer).apply_one_time &&
            parseOfferDetails(offerData.paired_offer).item_ids.includes(
              form.getAttribute('data-form-product')
            ))
        ) {
          if (
            (offerData.paired_offer &&
              parseOfferDetails(offerData.paired_offer).apply_one_time &&
              parseOfferDetails(offerData.paired_offer).item_ids.length ===
                0) ||
            (offerData.paired_offer &&
              parseOfferDetails(offerData.paired_offer).apply_one_time &&
              parseOfferDetails(offerData.paired_offer).item_ids.includes(
                form.getAttribute('data-form-product')
              ))
          ) {
            offerData = parseOfferDetails(offerData.paired_offer);
          }
          let priceDisplay = form.querySelector('.product__price');
          if (priceDisplay) {
            let originalPrice = parseFloat(
              priceDisplay.textContent.replace('$', '')
            );
            let offerPrice = originalPrice * offerData.discount;
            priceDisplay.innerHTML = `$${offerPrice.toFixed(2)} <span style="text-decoration: line-through; font-size: 0.85em; opacity: 0.7" data-content="discount-original-price">${priceDisplay.textContent}</span>`;
          }
        }
      }
    }
  });
}

// RC Native PDP's
function applyFormPricingOffer() {
  let productForms = document.querySelectorAll('[data-content="product-form"]');
  let offerData = parseOfferDetails(offer);
  let hasSubscriptions = parseHasSubscription();
  productForms.forEach((form) => {
    if (form.getAttribute('data-form-type') !== 'whistle') {
      parseAutoShipSelection(form);
      let basePrice = parseSelectionPrice(form);
      if (
        offerData &&
        offerData.item_ids &&
        (offerData.item_ids.length === 0 ||
          (offerData.item_ids.length > 0 &&
            offerData.item_ids.includes(
              form.getAttribute('data-form-product')
            )))
      ) {
        if (hasSubscriptions) {
          updateSubscriptionPrices(form, basePrice);
        }
      } else if (hasSubscriptions) {
        applyDefaultSubPricing(form, basePrice);
      }
    }
    const freshPriceEl = form.querySelector('[data-price-for="7042281439278"]');
    if (
      form.querySelector('[data-price-for="7042281439278"]') &&
      offerData.apply_ss &&
      (offerData.item_ids.length === 0 ||
        !offerData ||
        offerData.item_ids.includes(7042281439278))
    ) {
      const freshPriceBase = parseFloat(
        freshPriceEl.textContent.trim().replace('$', '')
      );
      const freshPrice = freshPriceBase * offerData.discount;
      freshPriceEl.innerHTML = `$${freshPrice.toFixed(2)} <span style="text-decoration: line-through; font-size: 0.85em; opacity: 0.7" data-content="discount-original-price">$${freshPriceBase}</span>`;

      const parent = freshPriceEl.closest('div');
      const dailyPriceEl = parent.querySelector('[data-price-type="per-day"]');
      if (!dailyPriceEl) return;
      const dailyPriceBase = parseFloat(
        dailyPriceEl.textContent.trim().replace('$', '')
      );
      const dailyPrice = dailyPriceBase * offerData.discount;
      dailyPriceEl.innerHTML = `$${dailyPrice.toFixed(2)} <span style="text-decoration: line-through; font-size: 0.85em; opacity: 0.7" data-content="discount-original-price">$${dailyPriceBase}</span>`;
    }
  });
}

// Fresh PDP LP Pricing Slash
function applyFreshLpSlash() {
  let productForms = document.querySelectorAll('[data-content="product-form"]');
  let offerData = parseOfferDetails(offer);
  productForms.forEach((form) => {
    const freshPriceEl = form.querySelector('[data-price-for="7042281439278"]');
    if (
      form.querySelector('[data-price-for="7042281439278"]') &&
      offerData.apply_ss &&
      (offerData.item_ids.length === 0 ||
        !offerData ||
        offerData.item_ids.includes(7042281439278))
    ) {
      const freshPriceBase = parseFloat(
        freshPriceEl.textContent.trim().replace('$', '')
      );
      const freshPrice = freshPriceBase * offerData.discount;
      freshPriceEl.innerHTML = `$${freshPrice.toFixed(2)} <span style="text-decoration: line-through; font-size: 0.85em; opacity: 0.7" data-content="discount-original-price">$${freshPriceBase}</span>`;

      const parent = freshPriceEl.closest('div');
      const dailyPriceEl = parent.querySelector('[data-price-type="per-day"]');
      if (!dailyPriceEl) return;
      const dailyPriceBase = parseFloat(
        dailyPriceEl.textContent.trim().replace('$', '')
      );
      const dailyPrice = dailyPriceBase * offerData.discount;
      dailyPriceEl.innerHTML = `$${dailyPrice.toFixed(2)} <span style="text-decoration: line-through; font-size: 0.85em; opacity: 0.7" data-content="discount-original-price">$${dailyPriceBase}</span>`;
    }
  });
}

function applyDefaultSubPricing(formEl, comparePrice) {
  let selectedFrequency = parseSelectedSubscription(formEl);
  formEl.querySelectorAll('[data-price-subsave]').forEach((displayPrice) => {
    if (
      selectedFrequency.getAttribute('data-frequency-unit-price') !==
      comparePrice
    ) {
      displayPrice.innerHTML = `$${selectedFrequency.getAttribute('data-frequency-unit-price')} <span style="text-decoration: line-through; font-size: 0.85em; opacity: 0.7">$${comparePrice}</span>`;
    }
  });
}

function updateSubscriptionPrices(productForm, fullPrice) {
  let offerData = parseOfferDetails(offer);
  if (
    offerData.apply_ss ||
    (offerData.paired_offer &&
      parseOfferDetails(offerData.paired_offer).apply_ss)
  ) {
    let discount;
    if (offerData.apply_ss) {
      discount = offerData.discount;
    } else {
      discount = parseOfferDetails(offerData.paired_offer).discount;
    }
    let subPrice = parseFloat(fullPrice) * discount;
    productForm
      .querySelectorAll('[data-price-subsave]')
      .forEach((displayPrice) => {
        displayPrice.innerHTML = `$${subPrice.toFixed(2)} <span style="text-decoration: line-through; font-size: 0.85em; opacity: 0.7" data-content="discount-original-price">$${fullPrice}</span>`;
      });
  } else {
    applyDefaultSubPricing(productForm, fullPrice);
  }
  if (
    offerData.apply_one_time ||
    (offerData.paired_offer &&
      parseOfferDetails(offerData.paired_offer).apply_one_time)
  ) {
    let otDiscount;
    if (offerData.apply_one_time) {
      otDiscount = offerData.discount;
    } else {
      otDiscount = parseOfferDetails(offerData.paired_offer).discount;
    }
    let otPrice = parseFloat(fullPrice) * otDiscount;
    productForm
      .querySelectorAll('[data-price-onetime]')
      .forEach((displayPrice) => {
        displayPrice.innerHTML = `$${otPrice.toFixed(2)} <span style="text-decoration: line-through; font-size: 0.85em; opacity: 0.7" data-content="discount-original-price">$${fullPrice}</span>`;
      });
  }
}

function parseSelectedSubscription(productForm) {
  let frequencySelector = productForm.querySelector('[data-plans-dropdown]');
  return frequencySelector.querySelector(
    `option[value="${frequencySelector.value}"]`
  );
}

function parseHasSubscription() {
  return document.querySelectorAll('[data-price-onetime]').length > 0;
}

// --------------------------------------------------------------------------------------------
// Event Listeners
// --------------------------------------------------------------------------------------------

function setVariantListeners() {
  let productForms = document.querySelectorAll('[data-content="product-form"]');
  productForms.forEach((form) => {
    let variantInputs = form.querySelectorAll('[data-variant-input]');
    variantInputs.forEach((input) => {
      input.addEventListener('change', productOptionsChange);
    });
  });
}

function setFrequencyListener(selectEl) {
  selectEl.addEventListener('change', productOptionsChange);
}

function setFrequencyListeners() {
  let productForms = document.querySelectorAll('[data-content="product-form"]');
  productForms.forEach((form) => {
    let frequencySelect = form.querySelector('[data-plans-dropdown]');
    setTimeout(function () {
      frequencySelect.addEventListener('change', productOptionsChange);
    }, 200);
  });
}

let autoshipChanged = false;

function handleFirstChange(trigger) {
  const form = trigger.closest('[data-content="product-form"]');
  let options = form
    .querySelector('[data-plans-dropdown]')
    .querySelectorAll('option');
  options[1].selected = true;
}

function setAutoshipListeners() {
  let productForms = document.querySelectorAll('[data-content="product-form"]');
  productForms.forEach((form) => {
    let optionSet = form.querySelector('[data-radio-group-options]');
    let inputs = optionSet.querySelectorAll('input[type="radio"]');
    inputs.forEach((input) => {
      input.addEventListener('change', (event) => {
        if (autoshipChanged === false) {
          autoshipChanged = true;
          handleFirstChange(event.target);
        }
        productOptionsChange();
      });
    });
  });
}

function productOptionsChange() {
  //applyFormPricingOffer()
  applyOfferDisplayPrice();
}

function updateCollectionListPricing() {
  const collectionSections = document.querySelectorAll(
    '[data-section-type="collection-template"]'
  );
  if (collectionSections.length === 0) return;

  collectionSections.forEach((section) => {
    const offersData = [];
    const mainOffer = parseOfferDetails(offer);
    offersData.push(mainOffer);
    if (mainOffer.paired_offer) {
      offersData.push(parseOfferDetails(mainOffer.paired_offer));
    }
    if (mainOffer.stackable_offers && mainOffer.stackable_offers.length > 0) {
      mainOffer.stackable_offers.forEach((offer) => {
        offersData.push(parseOfferDetails(offer));
      });
    }

    const prices = section.querySelectorAll('[data-price-for]');
    prices.forEach((price) => {
      let priceItemId = price.getAttribute('data-price-for');
      if (priceItemId) {
        priceItemId = parseInt(priceItemId);

        let matchedOffers = offersData.filter((offer) =>
          offer.item_ids.includes(priceItemId)
        );
        if (matchedOffers.length === 0) {
          let parentWithId = price.closest('[data-item-product-id]');
          priceItemId = parseInt(
            parentWithId.getAttribute('data-item-product-id')
          );
          matchedOffers = offersData.filter((offer) =>
            offer.item_ids.includes(priceItemId)
          );
        }
        if (matchedOffers.length > 0) {
          let bestOffer;
          matchedOffers.forEach((match) => {
            if (!bestOffer || match.discount < bestOffer.discount) {
              bestOffer = match;
            }
          });
          if (bestOffer) {
            let includesFrom = price.textContent.includes('from');
            let basePrice = parsePriceString(
              price.textContent.replace('from ', '').replace('from ', '')
            );
            let discountPrice = (basePrice * bestOffer.discount).toFixed(2);
            price.innerHTML = `${includesFrom ? 'from ' : ''}$${discountPrice} <span style="text-decoration: line-through; font-size: 0.85em; opacity: 0.7; font-weight: 400">$${basePrice}</span>`;
          }
        }
      }
    });
  });
}

function updateThresholdProps(contentJson) {
  const parent = document.querySelector('[data-content="bonus-thresholds"]');

  parent.removeAttribute('data-threshold-0');
  parent.removeAttribute('data-threshold-1');
  parent.removeAttribute('data-threshold-2');
  parent.removeAttribute('data-threshold-3');

  for (let i = 0; i < contentJson.length; i++) {
    parent.setAttribute(`data-threshold-${i}`, contentJson[i].threshold);
    if (i === contentJson.length - 1) {
      parent.setAttribute(`data-threshold-${i + 1}`, contentJson[i].threshold);
    }
  }
}

function constructThresholdGiftComponent() {
  const contentJson = checkSessionCartGiftEligibility(false);
  updateThresholdProps(contentJson);

  const currentSubtotal = parseFloat(
    document
      .querySelector('[data-content="bonus-thresholds"]')
      .getAttribute('data-current-subtotal')
  );
  let itemListHtml = '';
  let itemGaugeHtml = '';

  let lastThreshold = 0;

  for (let i = 0; i < contentJson.length; i++) {
    const amountAway = Math.max(contentJson[i].threshold - currentSubtotal, 0);
    const percentToGoal =
      amountAway === 0
        ? 100
        : lastThreshold > currentSubtotal
          ? 0
          : ((currentSubtotal - lastThreshold) /
              (contentJson[i].threshold - lastThreshold)) *
            100;

    lastThreshold = contentJson[i].threshold;
    const itemListItem = `
            <div class="threshold-goal--outer${percentToGoal === 100 ? ' threshold--active' : ''}" data-content="reward-threshold-${i}">
                <div class="threshold-goal--item">
                    <img src="${contentJson[i].image_url}" alt="Free Gift: ${contentJson[i].title}" class="responsive-bg--visual threshold-reward--image" loading="lazy">
                </div>
                <div class="threshold-goal--content">
                    <span data-content="goal-met">${contentJson[i].title}</span>
                    <span data-content="goal-pending">$${amountAway.toFixed(2)} Away</span>
                </div>
            </div>
        `;

    let itemGaugeItem = `
            <div class="threshold-progress--${i + 1}">
                <div class="threshold-progress--fill" style="width: ${percentToGoal}%" data-content="threshold-fill-${i}"></div>
            </div>
        `;

    if (i === contentJson.length - 1) {
      itemGaugeItem += `
                <div class="threshold-progress--${i + 2}">
                    <div class="threshold-progress--fill" style="width: ${percentToGoal === 100 ? 100 : 0}%" data-content="threshold-fill-${i + 1}"></div>
                </div>
            `;
    }

    itemListHtml += itemListItem;
    itemGaugeHtml += itemGaugeItem;
  }

  return `
        <div class="threshold-bar--wrapper">
            ${itemListHtml}
            <div class="threshold-gauge--border">
                <div class="threshold-goal--progress">
                    ${itemGaugeHtml}
                </div>
            </div>
        </div>
    `;
}

function enableCartThresholdGifts() {
  const cartThresholdGifts = document.querySelector(
    '[data-content="bonus-thresholds"]'
  );
  if (cartThresholdGifts) {
    const giftsContent = constructThresholdGiftComponent();
    cartThresholdGifts.innerHTML = giftsContent;
    cartThresholdGifts.classList.remove('hidden');
  }
}

function updateCartAttributes(attributes) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: attributes
    })
  })
    .then((response) => response.json())
    .then((data) => {
      cartAttributes = data.attributes;
    })
    .catch((error) => console.error('Error updating cart attributes:', error));
}

// --------------------------------------------------------------------------------------------

// Initialization actions

// --------------------------------------------------------------------------------------------

function initOfferFunctionality() {
  // Do these either way
  displayOfferAnnouncement();
  //checkRechargeState()
  setVariantListeners();
  checkOfferToggle();

  let gwpSetId =
    offer && parseOfferDetails(offer).gift_set_override
      ? parseOfferDetails(offer).gift_set_override
      : defaultGwpSet;
  if (gwpSetId && gwpSetId !== '') {
    gwpSet = setGwpSet(gwpSetId);
    if (!gwpSet && cartAttributes.gwp_set_id) {
      let attributes = cartAttributes;
      delete attributes.gwp_set_id;
      updateCartAttributes(attributes);
    } else if (
      gwpSet &&
      (!cartAttributes.gwp_set_id || cartAttributes.gwp_set_id !== gwpSet.id)
    ) {
      let attributes = cartAttributes;
      attributes.gwp_set_id = gwpSet.id;
      updateCartAttributes(attributes);
    }
    if (gwpSet && gwpSet.type === 'cart_threshold') {
      enableCartThresholdGifts();
    }
  }

  if (offer) {
    //applyFormPricingOffer()
    updateCollectionListPricing();
    //applyFreshLpSlash()
    applyOfferDisplayPrice();
  }
}

// --------------------------------------------------------------------------------------------

// Immediate checks and actions (not dom dependent)

// --------------------------------------------------------------------------------------------

parseOfferCookie();
// First, check for cookied offer
if (!offer && !wholesaleAccount) {
  const localOffer = localStorage.getItem('savedOffer')
    ? JSON.parse(localStorage.getItem('savedOffer'))
    : null;
  let localOfferValid = true;
  if (localOffer) {
    const now = new Date();
    const offerInitialized = new Date(localOffer.initialized);
    localOfferValid =
      now - offerInitialized <= 24 * 60 * 60 * 1000 &&
      !clearOffers.includes(localOffer.code);
    if (localOfferValid) {
      sessionStorage.setItem('offer', localOffer.code);
      offer = localOffer.code;
    }
  }
}

// If there is an offer, ensure customer is eligible to receive it
if (
  (offer &&
    parseOfferDetails(offer).existing_subscribers !== true &&
    existingSubscriber === true) ||
  (offer && clearOffers.includes(offer)) ||
  (offer && wholesaleAccount)
) {
  clearCurrentOffer();
}

// Now, if no offer is found, try to apply default offer

if (!offer && !Shopify.designMode && !wholesaleAccount) {
  if (defaultOffer && defaultOffer !== '') {
    // If the default offer has multiple options, choose one at random
    let applyOffer = !defaultOffer.includes(',')
      ? defaultOffer
      : defaultOffer.split(',')[
          Math.floor(Math.random() * defaultOffer.split(',').length)
        ];
    setDefaultOffer(applyOffer);
  }
}

if (
  offer &&
  parseOfferDetails(offer).whistle_gift &&
  !sessionStorage.getItem('whistle_gift_qty')
) {
  sessionStorage.setItem('whistle_gift_qty', '1');
  whistleData.credits += 1;
}

// --------------------------------------------------------------------------------------------

// DOM dependent intitialization

// --------------------------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', initOfferFunctionality);

// --------------------------------------------------------------------------------------------

// REFACTOR NEEDED FOR NUTRITION PLAN

// --------------------------------------------------------------------------------------------

function setOfferPrice(original) {
  if (!offer) return;
  let offerData = parseOfferDetails(offer);
  let amountNumber;
  if (typeof original === 'number') {
    amountNumber = original;
  } else {
    amountNumber = original.replace(/[^\d.-]/g, '');
  }
  let amountAdjusted = amountNumber;
  amountAdjusted = amountAdjusted * offerData.discount;
  let priceAdjusted = amountAdjusted.toFixed(2);
  return priceAdjusted;
}

document.addEventListener('ajaxProduct:added', checkOfferToggle);
document.addEventListener('cart:quantity', checkOfferToggle);
document.addEventListener('cart:updated', checkOfferToggle);
document.addEventListener('cart:build', checkOfferToggle);
